<template>
  <b-container v-if="!loading" class="d-flex flex-column h-100" fluid>
    <div
      class="pagetitle-container d-flex justify-content-between align-items-center mb-2"
    >
      <div class="page-title">
        <h2>{{ data.firstname }} {{ data.lastname }}</h2>
        <b-badge
          v-if="data.roles && data.roles[0].name === 'admin'"
          class="ml-1"
          variant="primary"
        >
          Administrator
        </b-badge>
      </div>
      <div class="ml-3">
        <b-btn class="mr-1" @click="openSetAvatarModal">
          <b-icon class="mr-1" icon="person-bounding-box" />
          Zmeniť profilový obrázok
        </b-btn>
        <b-btn @click="openChangePassModal">
          <b-icon class="mr-1" icon="key" />
          Zmeniť heslo
        </b-btn>
        <!--
        <b-btn
          variant="primary"
        >
          <b-icon
            class="mr-1"
            icon="pencil-square"
          />
          Upraviť
        </b-btn>-->
      </div>
    </div>
    <div v-bar class="profile">
      <div>
        <b-row>
          <b-col md="5">
            <div class="d-flex justify-content-center mb-5">
              <b-overlay :show="loadAvatar" rounded="circle">
                <b-avatar
                  :text="
                    $options.filters.initials(
                      `${data.firstname} ${data.lastname}`,
                    )
                  "
                  :src="`/storage/avatars/${data.avatar}_md.jpg`"
                  size="225px"
                  variant="light"
                  class="shadow-lg"
                />
              </b-overlay>
            </div>
            <b-form class="mb-5">
              <b-form-row class="mb-3">
                <b-col class="text-right" cols="4" tag="label"> Email:</b-col>
                <b-col cols="8">
                  <template v-if="data.email">
                    {{ data.email }}
                  </template>
                  <template v-else> -</template>
                </b-col>
              </b-form-row>
              <b-form-row class="mb-3">
                <b-col class="text-right" cols="4" tag="label">
                  Telefón:
                </b-col>
                <b-col cols="8">
                  <template v-if="data.phone">
                    {{ data.phone }}
                  </template>
                  <template v-else> -</template>
                </b-col>
              </b-form-row>
              <b-form-row class="mb-3">
                <b-col class="text-right" cols="4" tag="label"> Ulica:</b-col>
                <b-col cols="8">
                  <template v-if="data.street">
                    {{ data.street }} {{ data.streetNumber }}
                    <span v-if="data.streetRegNumber"
                      >/ {{ data.streetRegNumber }}</span
                    >
                  </template>
                  <template v-else> -</template>
                </b-col>
              </b-form-row>
              <b-form-row class="mb-3">
                <b-col class="text-right" cols="4" tag="label"> PSČ:</b-col>
                <b-col cols="8">
                  <template v-if="data.postCode">
                    {{ data.postCode }}
                  </template>
                  <template v-else> -</template>
                </b-col>
              </b-form-row>
              <b-form-row class="mb-3">
                <b-col class="text-right" cols="4" tag="label"> Mesto:</b-col>
                <b-col cols="8">
                  <template v-if="data.city">
                    {{ data.city }}
                  </template>
                  <template v-else> -</template>
                </b-col>
              </b-form-row>
              <template v-if="data.company">
                <hr />
                <b-form-row class="mb-3">
                  <b-col class="text-right" cols="4" tag="label">
                    Spoločnosť:
                  </b-col>
                  <b-col cols="8">
                    <template v-if="data.company.name">
                      {{ data.company.name }}
                    </template>
                    <template v-else> -</template>
                  </b-col>
                </b-form-row>
                <b-form-row class="mb-3">
                  <b-col class="text-right" cols="4" tag="label"> IČO:</b-col>
                  <b-col cols="8">
                    <template v-if="data.company.regNumber">
                      {{ data.company.regNumber }}
                    </template>
                    <template v-else> -</template>
                  </b-col>
                </b-form-row>
                <b-form-row class="mb-3">
                  <b-col class="text-right" cols="4" tag="label"> DIČ:</b-col>
                  <b-col cols="8">
                    <template v-if="data.company.taxNumber">
                      {{ data.company.taxNumber }}
                    </template>
                    <template v-else> -</template>
                  </b-col>
                </b-form-row>
                <b-form-row class="mb-3">
                  <b-col class="text-right" cols="4" tag="label">
                    IČ DPH:
                  </b-col>
                  <b-col cols="8">
                    <template v-if="data.company.taxRegNumber">
                      {{ data.company.taxRegNumber }}
                    </template>
                    <template v-else> -</template>
                  </b-col>
                </b-form-row>
                <b-form-row class="mb-3">
                  <b-col class="text-right" cols="4" tag="label">
                    Ulica:
                  </b-col>
                  <b-col cols="8">
                    <template v-if="data.company.street">
                      {{ data.company.street }} {{ data.company.streetNumber }}
                      <span v-if="data.company.streetRegNumber"
                        >/ {{ data.company.streetRegNumber }}</span
                      >
                    </template>
                    <template v-else> -</template>
                  </b-col>
                </b-form-row>
                <b-form-row class="mb-3">
                  <b-col class="text-right" cols="4" tag="label"> PSČ:</b-col>
                  <b-col cols="8">
                    <template v-if="data.company.postCode">
                      {{ data.company.postCode }}
                    </template>
                    <template v-else> -</template>
                  </b-col>
                </b-form-row>
                <b-form-row class="mb-3">
                  <b-col class="text-right" cols="4" tag="label">
                    Mesto:
                  </b-col>
                  <b-col cols="8">
                    <template v-if="data.company.city">
                      {{ data.company.city }}
                    </template>
                    <template v-else> -</template>
                  </b-col>
                </b-form-row>
              </template>
            </b-form>
          </b-col>
          <b-col md="7">
            <b-card class="card-shadow mb-4" title="Nastavenia">
              <b-row>
                <b-col sm="6">
                  <h4 class="fs-base mb-3">Notifikácie emailom</h4>
                  <b-form-group label-for="notifyOver">
                    <b-form-checkbox
                      v-model="settings.notifications.over"
                      :unchecked-value="0"
                      :value="1"
                      name="notifyOver"
                      size="sm"
                    >
                      Zasielať notifikácie o prekročení
                    </b-form-checkbox>
                  </b-form-group>
                  <b-form-group label-for="notifyNearOver">
                    <b-form-checkbox
                      v-model="settings.notifications.nearOver"
                      :unchecked-value="0"
                      :value="1"
                      name="notifyNearOver"
                      size="sm"
                    >
                      Zasielať notifikácie o dosiahnutí 85% hodnoty
                    </b-form-checkbox>
                  </b-form-group>
                  <template
                    v-if="
                      $root.user.isAdmin ||
                      $store.getters['user/can']('view operation')
                    "
                  >
                    <b-form-group label-for="notifyOperation">
                      <b-form-checkbox
                        v-model="settings.notifications.operation"
                        :unchecked-value="0"
                        :value="1"
                        name="notifyOperation"
                        size="sm"
                      >
                        Zasielať notifikácie o prevádzke
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group label-for="notifyWeatherPower">
                      <b-form-checkbox
                        v-model="settings.notifications.weatherPower"
                        :unchecked-value="0"
                        :value="1"
                        name="notifyWeatherPower"
                        size="sm"
                      >
                        Zasielať notifikácie o počasí (Elektrina)
                      </b-form-checkbox>
                    </b-form-group>
                    <b-form-group label-for="notifyWeatherGas">
                      <b-form-checkbox
                        v-model="settings.notifications.weatherGas"
                        :unchecked-value="0"
                        :value="1"
                        name="notifyWeatherGas"
                        size="sm"
                      >
                        Zasielať notifikácie o počasí (Plyn)
                      </b-form-checkbox>
                    </b-form-group>
                  </template>
                </b-col>
              </b-row>
              <template #footer>
                <b-btn variant="primary" @click="save"> Uložiť</b-btn>
              </template>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
    <set-avatar @saved="fetchData(true)" />
    <change-password />
  </b-container>
</template>
<script>
import ChangePassword from './ChangePassword'
import SetAvatar from './SetAvatar'

export default {
  components: {
    ChangePassword,
    SetAvatar,
  },
  data() {
    return {
      loading: false,
      data: [],
      settings: {
        notifications: {
          over: false,
          nearOver: false,
          operation: false,
          weatherPower: false,
          weatherGas: false,
        },
      },
      loadAvatar: false,
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    openSetAvatarModal() {
      this.$root.$emit('modal-show', 'set-avatar')
    },
    openChangePassModal() {
      this.$root.$emit('modal-show', 'change-password')
    },
    fetchData(silent = false) {
      this.loading = !silent
      this.loadAvatar = true
      this.$api
        .get('users/' + this.$store.state.user.current.id)
        .then((res) => {
          this.data = res.data
          this.settings.notifications = {
            over: res.data.notifyOver,
            nearOver: res.data.notifyNearOver,
            operation: res.data.notifyOperation,
            weatherPower: res.data.notifyWeatherPower,
            weatherGas: res.data.notifyWeatherGas,
          }
          this.$store.dispatch('user/setUser', res.data)
          if (!silent) {
            this.loading = false
          }
          this.loadAvatar = false
        })
    },
    save() {
      this.$api
        .post(
          'users/' + this.$store.state.user.current.id + '/save_settings',
          this.settings,
        )
        .then((res) => {
          this.$swal({
            type: 'success',
            position: 'top',
            showCloseButton: true,
            text: res.data.success,
            timer: 5000,
          })
        })
    },
  },
}
</script>
